export default __webpack_public_path__ + "static/media/crudearrivals-overlay.a833d514.svg";